// !Deprecated 09-feb-2026
// import * as RadixSwitch from '@radix-ui/react-switch'
// import { FC } from 'react'

// import { SwitchTypes } from './switch.types'

// export const Switch: FC<SwitchTypes> = ({ onChange }) => {
//   return (
//     <RadixSwitch.Root
//       className="w-[42px] cursor-pointer rounded-full border-2 border-transparent p-0 transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-blue-50 data-[state=unchecked]:bg-grey-20 data-[state=unchecked]:hover:bg-[#ccc8c8]"
//       onCheckedChange = {(checked) => {
//         if (onChange) {
//           onChange(checked)
//         }
//       }}
//     >
//       <RadixSwitch.Thumb className="pointer-events-none block h-[18px] w-[18px] rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0" />
//     </RadixSwitch.Root>
//   )
// }
import { FC, useState } from 'react';

import { SwitchTypes } from './switch.types';

export const Switch: FC<SwitchTypes> = ({ onChange }) => {
  const [checked, setChecked] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    setChecked(value);
    onChange?.(value);
  };

  return (
    <label
      className={`relative inline-block h-[22px] w-[42px] cursor-pointer rounded-full border-2 border-transparent p-0 transition-colors focus-within:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
        checked ? 'bg-blue-50' : 'bg-grey-20 hover:bg-[#ccc8c8]'
      }`}
    >
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        aria-checked={checked}
        className="peer sr-only"
        onChange={handleChange}
      />
      <span
        className={`pointer-events-none absolute block h-[18px] w-[18px] rounded-full bg-white shadow-lg ring-0 transition-transform ${
          checked ? 'translate-x-5' : 'translate-x-0'
        }`}
        aria-hidden
      />
    </label>
  );
};
